<div style="background-color: white;" class="quicksand" #container>

  <app-portada-fichas *ngIf="datos"   [grado]="true" [datos]="datos" [carrer]="carrer" [venue]="venue" [region]="region" [svgContent]="svgContent"></app-portada-fichas>

  <section class="  min section-primary " *ngIf="datos" id="section-primary-uno">
    <div class="contenedores-seccion">
      <div class="">
        <div class="">
          <app-porque-estudiar-en-uca [video]="datos.link" [title]="datos.why_title" [htmlEstudiar]="htmlEstudiar"
            [haveButton]="datos.button_signUp_state" [linkButton]="datos.button_signUp"></app-porque-estudiar-en-uca>
        </div>
      </div>
    </div>
  </section>
  <section class="banner-inscripcion" *ngIf="datos" id="banner-inscripcion">
    <div class="divimg">
      <img onerror="this.src='./assets/img/default.png'" class=" desk w-100 img-banner1"
        [src]="apiUrl +  datos.general_data_obj.banner_image_desk_url">
      <img onerror="this.src='./assets/img/default.png'" class="mob w-100 mob img-banner1"
        [src]="apiUrl+ datos.general_data_obj.banner_image_mobile_url">
    </div>


    <div class="banner-texto  " id="banner-texto-1">
      <h2 id="banner1-texto1" class="nunito-medium" [style.color]="datos.general_data_obj.banner_text_color">
        {{datos.general_data_obj.banner_text}}</h2>
      <h1 id="banner1-texto2" [style.color]="datos.general_data_obj.banner_subtitle_text_color" class="nunito-medium">
        {{datos.general_data_obj.banner_subtitle_text}}</h1>
      <a [href]="datos.general_data_obj.banner_image_link" class="" target="_blank" rel="noopener">
        <button id="banner-btn-1" class="btn-contacto nunito-medium zoomIn"
          [style.color]="datos.general_data_obj.banner_button_text_color"
          [style.backgroundColor]="datos.general_data_obj.banner_button_background_color">{{datos.general_data_obj.banner_button_text}}</button>
      </a>

    </div>

  </section>
  <section class="seccion-plan min" *ngIf="planData && datos">
    <div class="contenedores-seccion">
      <div class="">
        <div class="">
          <app-plan-de-estudio [planData]="planData" [titlesPlanData]="titlesPlanData"
            [dataGeneral]="datos.general_data_obj" [buttonStudyPlan]="datos.buttonStudyPlan" [html]="datos.graphic"
          [backgroudColor]="datos.color" [docentes]="datos.teaching" [workload]="datos.workload" [btnUcaState]="datos.button_visita_uca_state " [btnUca]="datos.button_visita_uca"></app-plan-de-estudio>
        </div>
      </div>
    </div>
  </section>

  <section class="min" *ngIf="datos">
    <div class="banner-experiencia" id="banner3">
      <div class="imgbanner-experiencia">

        <img onerror="this.src='./assets/img/default.png'" class=" desktop w-100 "
          src="./assets/img/Experiencia-UCA2.png">


        <img onerror="this.src='./assets/img/default.png'" class="mobile w-100  "
          src="./assets/img/Experiencia-UCA-mobile2.jpg">


      </div>
      <div class="textobanner-experiencia">

        <h1 id="banner3-texto1" class="quicksand-bold" [style.color]="datos.general_data_obj.banner_tres_title_color">
          {{datos.general_data_obj.banner_tres_title}}</h1>
        <h2 id="banner3-texto2" [style.color]="datos.general_data_obj.banner_tres_text_color" class="quicksand-medium">
          {{datos.general_data_obj.banner_tres_text}}</h2>
        <h2 id="banner3-texto3" [style.color]="datos.general_data_obj.banner_tres_text_dos_color"
          class="quicksand-bold">
          {{datos.general_data_obj.banner_tres_text_dos}}</h2>
        <div class="div-btn-experiencia">
          <a [href]="datos.general_data_obj.banner_tres_image_link" target="_blank" rel="noopener">

            <button id="banner3-btn-1" class="btn-experiencia nunito-medium zoomIn "
              [style.color]="datos.general_data_obj.banner_tres_button_text_color"
              [style.backgroundColor]="datos.general_data_obj.banner_tres_button_background_color"
              [style.border]="'1px solid' + datos.general_data_obj.banner_tres_button_border_color">{{datos.general_data_obj.banner_tres_button_text}}</button>
          </a>
        </div>


      </div>
    </div>

  </section>

  <section class="facsec2 min section-primary2 " id="section-primary ">
    <div class="container ">
      <div class="row">
        <div class="col-lg-12" id="container-hubspot">
          <h3 class="title">Completá tus datos para recibir más información </h3>

          <!--<div id="hubspot-form">
          </div>-->

            <app-form-hubspot portalId="23647426" formId="b2e6899b-83b4-4a49-92ff-92360afdd10d"></app-form-hubspot>

        </div>
      </div>
    </div>
  </section>


  <!-- 
  <section class="facsec2  min" *ngIf="datos">
    <div class="container mt-3">
      <div class="row">
        <div class="col-lg-12">
          <app-perfil-profesional [title]="datos.profile_title" [htmlPerfil]="htmlPerfil"></app-perfil-profesional>
        </div>
      </div>
    </div>
  </section>
  <section class="facsec2  min" *ngIf='datos && datos.benefitsButtons'>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <section class="logsec3">
            <div class="container">
              <div class="row">
                <div class="col-lg-12">
                  <app-icons [data]='datos.benefitsButtons'></app-icons>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
  <section class="facsec2 min" id='container-video' *ngIf="iframe">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <h2>Conocenos</h2>
          <p *ngIf='iframe' style="display: flex;">
            <iframe width='900' height='500' [src]="iframe" frameborder="0" allowfullscreen></iframe>
          </p>
        </div>
  
      </div>
    </div>
  </section>
   -->

</div>